/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_Managing_GroupInputs */

const en_us2_plan_no_managing_group = /** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not train this person through any group.`)
};

const pt_br2_plan_no_managing_group = /** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não treina essa pessoa por nenhuma turma.`)
};

const pt_pt2_plan_no_managing_group = /** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não treina essa pessoa por nenhuma turma.`)
};

/** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */
const es_419_plan_no_managing_group = en_us2_plan_no_managing_group;

/** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */
const fr_fr2_plan_no_managing_group = en_us2_plan_no_managing_group;

/** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */
const de_de2_plan_no_managing_group = en_us2_plan_no_managing_group;

/** @type {(inputs: Plan_No_Managing_GroupInputs) => LocalizedString} */
const it_it2_plan_no_managing_group = en_us2_plan_no_managing_group;

/**
* | output |
* | --- |
* | "You do not train this person through any group." |
*
* @param {Plan_No_Managing_GroupInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_no_managing_group = /** @type {((inputs?: Plan_No_Managing_GroupInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_Managing_GroupInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_no_managing_group(inputs)
	if (locale === "es-419") return es_419_plan_no_managing_group(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_no_managing_group(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_no_managing_group(inputs)
	if (locale === "de-DE") return de_de2_plan_no_managing_group(inputs)
	if (locale === "it-IT") return it_it2_plan_no_managing_group(inputs)
	return en_us2_plan_no_managing_group(inputs)
});
export { plan_no_managing_group as "plan.no_managing_group" }